export const FETCH_RD_FILTER_CUSTOMERS_REQUEST = "FETCH_RD_FILTER_CUSTOMERS_REQUEST";
export const FETCH_RD_FILTER_CUSTOMERS_SUCCESS = "FETCH_RD_FILTER_CUSTOMERS_SUCCESS";
export const FETCH_RD_FILTER_CUSTOMERS_FAILURE = "FETCH_RD_FILTER_CUSTOMERS_FAILURE";

export const FETCH_RD_FILTER_LOCATIONS_REQUEST = "FETCH_RD_FILTER_LOCATIONS_REQUEST";
export const FETCH_RD_FILTER_LOCATIONS_SUCCESS = "FETCH_RD_FILTER_LOCATIONS_SUCCESS";
export const FETCH_RD_FILTER_LOCATIONS_FAILURE = "FETCH_RD_FILTER_LOCATIONS_FAILURE";

export const FETCH_RD_FILTER_PROVIDERS_REQUEST = "FETCH_RD_FILTER_PROVIDERS_REQUEST";
export const FETCH_RD_FILTER_PROVIDERS_SUCCESS = "FETCH_RD_FILTER_PROVIDERS_SUCCESS";
export const FETCH_RD_FILTER_PROVIDERS_FAILURE = "FETCH_RD_FILTER_PROVIDERS_FAILURE";

export const FETCH_REPORT_DASHBOARD_REQUEST = "FETCH_REPORT_DASHBOARD_REQUEST";
export const FETCH_REPORT_DASHBOARD_SUCCESS = "FETCH_REPORT_DASHBOARD_SUCCESS";
export const FETCH_REPORT_DASHBOARD_FAILURE = "FETCH_REPORT_DASHBOARD_FAILURE";

export const FETCH_PROVIDER_TIME_SUMMARY_REQUEST = "FETCH_PROVIDER_TIME_SUMMARY_REQUEST";
export const FETCH_PROVIDER_TIME_SUMMARY_SUCCESS = "FETCH_PROVIDER_TIME_SUMMARY_SUCCESS";
export const FETCH_PROVIDER_TIME_SUMMARY_FAILURE = "FETCH_PROVIDER_TIME_SUMMARY_FAILURE";

export const FETCH_PATIENT_ENGAGEMENT_REQUEST = "FETCH_PATIENT_ENGAGEMENT_REQUEST";
export const FETCH_PATIENT_ENGAGEMENT_SUCCESS = "FETCH_PATIENT_ENGAGEMENT_SUCCESS";
export const FETCH_PATIENT_ENGAGEMENT_FAILURE = "FETCH_PATIENT_ENGAGEMENT_FAILURE";

export const FETCH_ADHERENCE_TREND_REQUEST = "FETCH_ADHERENCE_TREND_REQUEST";
export const FETCH_ADHERENCE_TREND_SUCCESS = "FETCH_ADHERENCE_TREND_SUCCESS";
export const FETCH_ADHERENCE_TREND_FAILURE = "FETCH_ADHERENCE_TREND_FAILURE";

export const FETCH_PE_PATIENT_DETAILS_REQUEST = "FETCH_PE_PATIENT_DETAILS_REQUEST";
export const FETCH_PE_PATIENT_DETAILS_SUCCESS = "FETCH_PE_PATIENT_DETAILS_SUCCESS";
export const FETCH_PE_PATIENT_DETAILS_FAILURE = "FETCH_PE_PATIENT_DETAILS_FAILURE";
export const SET_PE_PATIENT_DETAILS_SORT = "SET_PE_PATIENT_DETAILS_SORT";

export const FETCH_RTM_CLAIMS_REQUEST = "FETCH_RTM_CLAIMS_REQUEST";
export const FETCH_RTM_CLAIMS_SUCCESS = "FETCH_RTM_CLAIMS_SUCCESS";
export const FETCH_RTM_CLAIMS_FAILURE = "FETCH_RTM_CLAIMS_FAILURE";

export const SET_RTM_CLAIM_DETAILS_TAB = "SET_RTM_CLAIM_DETAILS_TAB";
export const FETCH_RTM_CLAIM_DETAILS_REQUEST = "FETCH_RTM_CLAIM_DETAILS_REQUEST";
export const FETCH_RTM_CLAIM_DETAILS_SUCCESS = "FETCH_RTM_CLAIM_DETAILS_SUCCESS";
export const FETCH_RTM_CLAIM_DETAILS_FAILURE = "FETCH_RTM_CLAIM_DETAILS_FAILURE";

export const FETCH_DF_NPS_REQUEST = "FETCH_DF_NPS_REQUEST";
export const FETCH_DF_NPS_SUCCESS = "FETCH_DF_NPS_SUCCESS";
export const FETCH_DF_NPS_FAILURE = "FETCH_DF_NPS_FAILURE";

export const FETCH_DF_OUTCOMES_REQUEST = "FETCH_DF_OUTCOMES_REQUEST";
export const FETCH_DF_OUTCOMES_SUCCESS = "FETCH_DF_OUTCOMES_SUCCESS";
export const FETCH_DF_OUTCOMES_FAILURE = "FETCH_DF_OUTCOMES_FAILURE";

export const FETCH_DF_OUTCOMES_TREND_REQUEST = "FETCH_DF_OUTCOMES_TREND_REQUEST";
export const FETCH_DF_OUTCOMES_TREND_SUCCESS = "FETCH_DF_OUTCOMES_TREND_SUCCESS";
export const FETCH_DF_OUTCOMES_TREND_FAILURE = "FETCH_DF_OUTCOMES_TREND_FAILURE";

export const FETCH_DF_NPS_TREND_REQUEST = "FETCH_DF_NPS_TREND_REQUEST";
export const FETCH_DF_NPS_TREND_SUCCESS = "FETCH_DF_NPS_TREND_SUCCESS";
export const FETCH_DF_NPS_TREND_FAILURE = "FETCH_DF_NPS_TREND_FAILURE";

export const FETCH_DF_COMMENTS_REQUEST = "FETCH_DF_COMMENTS_REQUEST";
export const FETCH_DF_COMMENTS_SUCCESS = "FETCH_DF_COMMENTS_SUCCESS";
export const FETCH_DF_COMMENTS_FAILURE = "FETCH_DF_COMMENTS_FAILURE";
export const SET_DF_COMMENTS_SORT = "SET_DF_COMMENTS_SORT";

export const FETCH_PROVIDER_ENGAGEMENT_SUMMARY_REQUEST = "FETCH_PROVIDER_ENGAGEMENT_SUMMARY_REQUEST";
export const FETCH_PROVIDER_ENGAGEMENT_SUMMARY_SUCCESS = "FETCH_PROVIDER_ENGAGEMENT_SUMMARY_SUCCESS";
export const FETCH_PROVIDER_ENGAGEMENT_SUMMARY_FAILURE = "FETCH_PROVIDER_ENGAGEMENT_SUMMARY_FAILURE";

export const FETCH_PROVIDER_ENGAGEMENT_TREND_REQUEST = "FETCH_PROVIDER_ENGAGEMENT_TREND_REQUEST";
export const FETCH_PROVIDER_ENGAGEMENT_TREND_SUCCESS = "FETCH_PROVIDER_ENGAGEMENT_TREND_SUCCESS";
export const FETCH_PROVIDER_ENGAGEMENT_TREND_FAILURE = "FETCH_PROVIDER_ENGAGEMENT_TREND_FAILURE";

export const FETCH_PROVIDER_ENGAGEMENT_PROVIDERS_REQUEST = "FETCH_PROVIDER_ENGAGEMENT_PROVIDERS_REQUEST";
export const FETCH_PROVIDER_ENGAGEMENT_PROVIDERS_SUCCESS = "FETCH_PROVIDER_ENGAGEMENT_PROVIDERS_SUCCESS";
export const FETCH_PROVIDER_ENGAGEMENT_PROVIDERS_FAILURE = "FETCH_PROVIDER_ENGAGEMENT_PROVIDERS_FAILURE";
export const SET_PROVIDER_ENGAGEMENT_PROVIDERS_SORT = "SET_PROVIDER_ENGAGEMENT_PROVIDERS_SORT";

export const SET_PATIENT_ENGAGEMENT_THRESHOLDS = "SET_PATIENT_ENGAGEMENT_THRESHOLDS";

export const SET_REPORT_DASHBOARD_ACTIVE_SECTION = "SET_REPORT_DASHBOARD_ACTIVE_SECTION";
export const SET_REPORT_DASHBOARD_FILTER = "SET_REPORT_DASHBOARD_FILTER";
export const SET_REPORT_DASHBOARD_FILTERS_PATCH = "SET_REPORT_DASHBOARD_FILTERS_PATCH";
export const APPLY_REPORT_DASHBOARD_FILTERS = "APPLY_REPORT_DASHBOARD_FILTERS";
export const DISCARD_REPORT_DASHBOARD_FILTER_DRAFT = "DISCARD_REPORT_DASHBOARD_FILTER_DRAFT";
export const COMMIT_REPORT_DASHBOARD_FILTER_PATCH = "COMMIT_REPORT_DASHBOARD_FILTER_PATCH";
export const RESET_REPORT_DASHBOARD_FILTERS = "RESET_REPORT_DASHBOARD_FILTERS";
export const SNAPSHOT_FILTERS_BEFORE_RTM = "SNAPSHOT_FILTERS_BEFORE_RTM";
export const RESTORE_FILTERS_FROM_RTM_SNAPSHOT = "RESTORE_FILTERS_FROM_RTM_SNAPSHOT";
export const RESET_REPORT_DASHBOARD = "RESET_REPORT_DASHBOARD";
export const SET_REPORT_DASHBOARD_DATA_OWNER = "SET_REPORT_DASHBOARD_DATA_OWNER";
export const SET_REPORT_DASHBOARD_FILTERS_BOOTSTRAPPED = "SET_REPORT_DASHBOARD_FILTERS_BOOTSTRAPPED";
